import { watch } from 'vue'
import { useGlobalCall } from './useGlobalCall.js'

/**
 * Branche l'appel global au niveau racine de l'app : expose useGlobalCall tel quel
 * et ajoute le seul effet propre à App.vue — la classe `has-call-banner` sur <body>
 * quand un appel est en cours (décale la mise en page sous la bannière).
 */
export function useAppCallHandlers() {
  const globalCall = useGlobalCall()

  watch(globalCall.callInProgress, (isActive) => {
    document.body.classList.toggle('has-call-banner', isActive)
  })

  return globalCall
}
